import * as React from 'react';

// Placeholder for a page that is still loading
// This is used to prevent footer showing right below the header when the page is still loading
const PagePlaceholder = () => {
  return <div style={{ height: '100vh' }} />;
};

export default PagePlaceholder;
